<template>
  <div>
    <div class="floral-bg-image"></div>
    <div class="center-container has-margin-top has-width error-page">
      <h1 class="error-page__title">Oops!</h1>
      <h2 class="error-page__sub-title">
        We can't seem to find the page you're looking for.
      </h2>
      <small>Error code: 404</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pageNotFound',
  metaInfo: {
    title: 'Berries and Blooms - 404 Page Not Found',
    links: [
      { rel: 'canonical', href: '/*' },
    ],
  },
}
</script>

<style lang="scss">
  .floral-bg-image {
    background-image: url('~@/assets/flowers_bg.png');
    background-position: 100%;
    background-repeat: repeat;
    background-size: cover;
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: 0;
    opacity: .1;

    &::before {
      content: '';
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 0;
    }
  }
</style>
